import react, { useState } from 'react';
import i18next from 'i18next';

import ResetRequestView from './ResetRequestView';
import Network from '../../lib/Network';
import { getLanguage, getSearchParams } from '../../lib/environment';

export default function ResetRequest(props) {
  const [message, setMessage] = useState('');
  const [state, setState] = useState('initial');
  const onSubmit = email => {
    setState('waiting');
    Network.postResetRequest(email, getLanguage(), getRedirect())
      .then(result => {
        if (result.status === 'SUCCESS') {
          setValues('sent', 'reset.emailSent');
        } else {
          setValues('initial', 'error.internalError');
        }
      })
      .catch(error => {
        console.log(error);
        setState('initial');
        setMessage(i18next.t('error.networkError'))
      });
  }
  return <ResetRequestView onSubmit={onSubmit} message={message} state={state} />;

  function setValues(newState, newMessage) {
    setState(newState);
    setMessage(i18next.t(newMessage));
  }

  function getRedirect() {
    return getSearchParams().redirect;
  }
}
